import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-unauthenticated-footer',
  templateUrl: './unauthenticated-footer.component.html',
  styleUrls: ['./unauthenticated-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UnauthenticatedFooterComponent implements OnInit {
  public currentYear = '';

  constructor() {}

  ngOnInit(): void {
    this.currentYear = moment().format('YYYY');
  }
}
